<template>
    <div class="nav-top">
        <div class="nav-top-content clearfix">
            <div class="nav-tit-left">
                <h1>17共享网检验检测能力数据库</h1>
            </div>
            <div class="nav-right">
                <nav-login />
            </div>
            <Login/>
        </div>
    </div>
</template>

<script>
  import Login from '@/components/common/Login'
  import NavLogin from '@/components/common/NavLogin'

  export default {
    data () {
      return {
      }
    },
    methods: {
    },
    components: {
      Login,
      NavLogin
    },
    mounted () {
    }
  }
</script>

<style scoped>
    .nav-top {
        background: #021221;
    }

    .nav-top .nav-top-content {
        width: 1200px;
        margin: 0 auto;
        color: #fff;
        height: 60px;
        line-height: 60px;
    }

    .nav-top-content .nav-tit-left {
        float: left;
        font-size: 12px;
    }

    .nav-top-content .nav-right {
        float: right;
    }

    .clearfix:after {
        content: ".";
        clear: both;
        height: 0;
        overflow: hidden;
        visibility: hidden;
        display: block;
    }

    .clearfix {
        zoom: 1;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/NavTop.vue